import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useData } from '@hooks/useData';

export const AwardLogo: FC = () => {
    const { allSettings } = useData();
    const { t } = useTranslation();

    const translations = {
        awardLogoAlt: t('award-logo.alt'),
    };

    return (
        <>
            {allSettings?.data?.awardLogo?.src && (
                <div className="align-self-center py-4 py-lg-3">
                    <div className="d-flex justify-content-center">
                        <img
                            style={{ maxHeight: '60px', maxWidth: '100%' }}
                            src={allSettings?.data.awardLogo?.src}
                            alt={translations.awardLogoAlt}
                        />
                    </div>
                </div>
            )}
        </>
    );
};
